module.exports = __webpack_public_path__ + "img/Camera&lens7.af7f8ceb.png";